export default __webpack_public_path__ + "static/media/Oilers.f56c1cfe.png";